module.exports = __webpack_public_path__ + "cd455783/img/print-icon.d8dbbca5.svg";